// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/pursuit.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { CaptureProjectSummary } from "./projectdata_pb";
import { QualificationHandoffSnapshot } from "../../datagateway/v1/pursuit_open_pb";
/**
 * @generated from message mono.projectdata.v1.OpenPursuitRequest
 */ export class OpenPursuitRequest extends Message {
    static fromBinary(bytes, options) {
        return new OpenPursuitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenPursuitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenPursuitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenPursuitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * required; mint one per deliberate open, reuse on retry
   *
   * @generated from field: string opening_request_id = 1;
   */ _define_property(this, "openingRequestId", ""), /**
   * optional canonical Opportunity
   *
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * optional qualification input
   *
   * @generated from field: string qualification_id = 3;
   */ _define_property(this, "qualificationId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * overridden by the gateway principal when present
   *
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * overridden by the gateway principal when present
   *
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string account_id = 7;
   */ _define_property(this, "accountId", ""), /**
   * @generated from field: string customer_org_id = 8;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string opportunity_hypothesis = 9;
   */ _define_property(this, "opportunityHypothesis", ""), /**
   * optional selective Qualification handoff (SAD-480)
   *
   * @generated from field: mono.projectdata.v1.QualificationHandoff handoff = 10;
   */ _define_property(this, "handoff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenPursuitRequest, "runtime", proto3);
_define_property(OpenPursuitRequest, "typeName", "mono.projectdata.v1.OpenPursuitRequest");
_define_property(OpenPursuitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opening_request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "qualification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "account_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "opportunity_hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "handoff",
            kind: "message",
            T: QualificationHandoff
        }
    ]));
/**
 * QualificationHandoff selects which context of the Opportunity's "pursue"
 * Qualification carries into the Pursuit; each carried item keeps its lineage to
 * the evaluated version. FailedPrecondition when the latest disposition is not
 * pursue. Applied on first open only; a retry returns the same Pursuit.
 *
 * @generated from message mono.projectdata.v1.QualificationHandoff
 */ export class QualificationHandoff extends Message {
    static fromBinary(bytes, options) {
        return new QualificationHandoff().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QualificationHandoff().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QualificationHandoff().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QualificationHandoff, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evaluation_id = 1;
   */ _define_property(this, "evaluationId", ""), /**
   * "rationale" or "answer:<criterion id>"
   *
   * @generated from field: repeated string selected_keys = 2;
   */ _define_property(this, "selectedKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QualificationHandoff, "runtime", proto3);
_define_property(QualificationHandoff, "typeName", "mono.projectdata.v1.QualificationHandoff");
_define_property(QualificationHandoff, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "selected_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.OpenPursuitResponse
 */ export class OpenPursuitResponse extends Message {
    static fromBinary(bytes, options) {
        return new OpenPursuitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenPursuitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenPursuitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenPursuitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureProjectSummary summary = 1;
   */ _define_property(this, "summary", void 0), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string qualification_id = 3;
   */ _define_property(this, "qualificationId", ""), /**
   * @generated from field: bool created = 4;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenPursuitResponse, "runtime", proto3);
_define_property(OpenPursuitResponse, "typeName", "mono.projectdata.v1.OpenPursuitResponse");
_define_property(OpenPursuitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "message",
            T: CaptureProjectSummary
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "qualification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPursuitOpeningRequest
 */ export class GetPursuitOpeningRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitOpeningRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitOpeningRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitOpeningRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitOpeningRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * overridden by the gateway principal when present
   *
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * overridden by the gateway principal when present
   *
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitOpeningRequest, "runtime", proto3);
_define_property(GetPursuitOpeningRequest, "typeName", "mono.projectdata.v1.GetPursuitOpeningRequest");
_define_property(GetPursuitOpeningRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPursuitOpeningResponse
 */ export class GetPursuitOpeningResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitOpeningResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitOpeningResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitOpeningResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitOpeningResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string qualification_id = 2;
   */ _define_property(this, "qualificationId", ""), /**
   * @generated from field: mono.datagateway.v1.QualificationHandoffSnapshot qualification_handoff = 3;
   */ _define_property(this, "qualificationHandoff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitOpeningResponse, "runtime", proto3);
_define_property(GetPursuitOpeningResponse, "typeName", "mono.projectdata.v1.GetPursuitOpeningResponse");
_define_property(GetPursuitOpeningResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "qualification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "qualification_handoff",
            kind: "message",
            T: QualificationHandoffSnapshot
        }
    ]));
